import axios from 'axios';
import Cookies from 'js-cookie';

const endpoint = process.env.VUE_APP_B2B_BACKEND_ENDPOINT;

const instance = axios.create({
    baseURL: endpoint
});
instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;

// Where you would set stuff like your 'Authorization' header, etc ...
let jwt = Cookies.get('b2b_bearer')
if (jwt) {
    instance.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
}

export default instance;